import DataTable from "../Reusable/DataTable";
import NACell from "../Reusable/DataTable/NACell";
import APIS from "../../constant/EndPoint";
import TableActionButton from "../Reusable/TableActionButton";
import SwitchButton from "../Reusable/SwitchButton";
//@ts-ignore
import { AccessControl } from "@careinfo/permission-required";
import { useNavigate } from "react-router-dom";
const BranchList = (props: any) => {
  const { handleIsActive, handleIsEnableEmail, handleIsEnableSMS } = props;
  const navigate = useNavigate();
  const handleRowClick = (row: any) => {
    navigate(`edit/${row.original.id}`);
  };

  const defaultColumns: any = [
    {
      header: "Name",
      accessorKey: "name",
      cell: NACell,
    },
    {
      header: "Company Name",
      accessorKey: "company_name",
      cell: NACell,
    },
    {
      header: "Code",
      accessorKey: "code",
      cell: NACell,
    },
    {
      header: "VAT/PAN",
      accessorKey: "vat_pan",
      cell: NACell,
    },
    {
      header: "Contact",
      accessorKey: "primary_contact",
      cell: NACell,
    },
    {
      header: "Email",
      accessorKey: "primary_email",
      cell: NACell,
    },
    {
      header: "Warehouse",
      accessorKey: "warehouse.name",
      cell: NACell,
    },
    {
      header: "Branch Manager",
      accessorKey: "manager.name",
      cell: NACell,
    },
    {
      header: "SMS",
      accessorKey: "is_enable_sms",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsEnableSMS}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsEnableSMS}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Email",
      accessorKey: "is_enable_email",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsEnableEmail}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsEnableEmail}
              />
            }
          />
        </div>
      ),
    },
    {
      header: "Active",
      accessorKey: "is_active",
      cell: ({ row, getValue }) => (
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
        >
          <AccessControl
            children={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={false}
                onChange={handleIsActive}
              />
            }
            allowedPermissions={["can_update_setting"]}
            renderNoAccess={
              <SwitchButton
                id={row?.original?.id}
                value={getValue()}
                disabled={true}
                onChange={handleIsActive}
              />
            }
          />
        </div>
      ),
    },
    // {
    //   header: "Action",
    //   accessorKey: "id",
    //   cell: ({ row, getValue }: any) => (
    //     <>
    //       <AccessControl
    //         children={<TableActionButton editPath={`/edit/${getValue()}`} />}
    //         allowedPermissions={["can_update_setting"]}
    //       />
    //     </>
    //   ),
    // },
  ];

  return (
    <DataTable
      url={APIS.BRANCH}
      queryKey={"branch"}
      columns={defaultColumns}
      addNewPagePath={"/create"}
      tableName={"branch"}
      onRowClick={handleRowClick}
    />
  );
};

export default BranchList;
